module.exports = __webpack_public_path__ + "img/kaley.ec53f889.jpeg";